import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login'
import Logout from './components/Logout'
import Warehouse from './components/Warehouse'
import WarehouseLive from './components/WarehouseLive'
import Report from './components/Report'
import Users from './components/Users'
import App from './App'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { 
      path: '/', 
      component: Login,
      meta:
      {
        requiresAuth: false
      }
    },
    {
      path: '/login', component: Login, meta:
      {
        requiresAuth: false
      }
    },
    {
      path: '/logout', component: Logout, meta:
      {
        requiresAuth: true
      }
    },
    {
      path: '/warehouse', component: Warehouse, meta:
      {
        requiresAuth: true
      }
    },
    {
      path: '/warehouselive', component: WarehouseLive, meta:
      {
        requiresAuth: true
      }
    },
    {
      path: '/report', component: Report, meta:
      {
        requiresAuth: true
      }
    },
    {
      path: '/users', component: Users, meta:
      {
        requiresAuth: true
      }
    },
  ]
})
